import actions from "@/store/modules/organisations/organisation-message-templates/actions";
import {
  mutations,
  state
} from "@/store/modules/organisations/organisation-message-templates/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
